import { Button, TextField, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	changeStatusSupplier,
	deleteSupplier,
	getSuppliers,
} from "../../../../api/supplier";
import { getSupplierTypes } from "../../../../api/supplierType";
import { ROLES } from "../../../../utils/constants";
import { normalizeString } from "../../../../utils/helpers";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import FiltersCard from "../../../components/filters/Filter";
import Table, {
	buttonsStyle,
	getCurrentTablePage,
} from "../../../components/tables/table";
import SupplierContent from "./SupplierContent";

function getData(suppliers) {
	let data = [];
	for (let i = 0; i < suppliers.length; ++i) {
		const elem = {};
		const supplier = suppliers[i];

		elem.nombre = supplier?.nombre;
		elem.tipoProveedor = supplier?.tipo_proveedor?.descripcion;
		elem.poblacion = supplier?.poblacion;
		elem.provincia = supplier?.provincia;
		elem.activo = supplier?.activo;
		elem.id = supplier?.id;

		data = data.concat(elem);
	}
	return data;
}

const initialFilters = {
	provincia: "",
	poblacion: "",
	tipoProveedor: "",
};

export default function SuppliersPage() {
	const [data, setData] = useState([]);
	const [selectedSupplier, setSelectedSupplier] = useState(null);

	const [supplierTypes, setSupplierTypes] = useState([]);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openSupplierInfoDialog, setOpenSupplierInfoDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const [filteredData, setFilteredData] = useState([]);
	const [collapsed, setCollapsed] = useState(true);
	const [filterOptions, setFilterOptions] = useState(initialFilters);

	const history = useHistory();
	const location = useLocation();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							history.push({
								pathname: "/proveedores/" + cell + "/edit",
								state: {
									page: getCurrentTablePage(location),
								},
							});
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip
							title={elem?.activo ? "Desactivar" : "Activar"}
						>
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedSupplier(elem);
									setOpenConfirmDialog(1);
								}}
							>
								{elem?.activo ? (
									<ToggleOffIcon />
								) : (
									<ToggleOnIcon style={{ color: "red" }} />
								)}
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedSupplier(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "nombre", text: "Nombre Comercial", sort: true },
		{
			dataField: "tipoProveedor",
			text: "Tipo de Proveedor",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "poblacion",
			text: "Población",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{
			dataField: "provincia",
			text: "Provincia",
			sort: true,
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getSupplierTypes(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setSupplierTypes(res.data);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se han podido obtener los tipos de proveedores.",
				});
			});
		getSuppliers(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setFilteredData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener los proveedores.",
				});
			});
	}, [refresh]);

	function getTowns() {
		let uniqueTowns = Array.from(
			new Set(
				data?.map((x) => x.poblacion && normalizeString(x.poblacion))
			)
		);

		return uniqueTowns;
	}

	function getProvinces() {
		let uniqueProvinces = Array.from(
			new Set(
				data?.map((x) => x.provincia && normalizeString(x.provincia))
			)
		);

		return uniqueProvinces;
	}

	const handleSearch = async () => {
		if (!data.length) return;
		setFilteredData(
			data.filter((item) => {
				let filter = true;
				if (filterOptions.poblacion)
					filter =
						filter &&
						normalizeString(filterOptions.poblacion) ===
							normalizeString(item.poblacion);
				if (filterOptions.provincia)
					filter =
						filter &&
						normalizeString(filterOptions.provincia) ===
							normalizeString(item.provincia);
				if (filterOptions.tipoProveedor)
					filter =
						filter &&
						filterOptions.tipoProveedor.id ===
							item.tipo_proveedor?.id;
				if (filter) return item;
				return false;
			})
		);
	};

	const handleClearFilters = () => {
		setFilterOptions(initialFilters);
		setRefresh(true);
	};

	const renderFiltersContent = () => {
		return (
			<>
				<div className="d-sm-flex w-100">
					<Autocomplete
						className="w-100 mr-5"
						id="autocomplete-poblacion"
						filterSelectedOptions
						options={getTowns()}
						getOptionLabel={(option) => option}
						value={filterOptions.poblacion || ""}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								poblacion: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Población"
							/>
						)}
					/>
					<Autocomplete
						className="w-100 mr-5"
						id="autocomplete-provincia"
						filterSelectedOptions
						options={getProvinces()}
						getOptionLabel={(option) => option}
						value={filterOptions.provincia || ""}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								provincia: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Provincia"
							/>
						)}
					/>
					<Autocomplete
						className="w-100 mr-5"
						id="autocomplete-tipo-proveedor"
						filterSelectedOptions
						options={supplierTypes}
						getOptionLabel={(option) => option.descripcion}
						value={filterOptions.tipoProveedor || ""}
						onChange={(event, selected) => {
							setFilterOptions({
								...filterOptions,
								tipoProveedor: selected,
							});
						}}
						renderInput={(params) => (
							<TextField
								{...params}
								margin="normal"
								variant="outlined"
								InputLabelProps={{
									shrink: true,
								}}
								label="Tipo de proveedor"
							/>
						)}
					/>
				</div>
			</>
		);
	};

	return (
		<>
			<Card>
				<CardHeader headerClassName="px-0">
					<CardHeader
						title="Proveedores"
						sticky={false}
						headerClassName="d-flex justify-content-between w-100 py-3"
					>
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() =>
									history.push({
										pathname: "/proveedores/edit",
									})
								}
							>
								Nuevo proveedor
							</button>
						</CardHeaderToolbar>
					</CardHeader>
					<div className="w-100">
						<FiltersCard
							collapsable={false}
							filtersContent={renderFiltersContent}
							collapsed={collapsed}
							setCollapsed={setCollapsed}
							handleClearFilters={handleClearFilters}
							handleSearch={handleSearch}
						/>
					</div>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(filteredData)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const supplier = data?.find(
									(x) => x.id === row.id
								);
								setSelectedSupplier(supplier);
								setOpenSupplierInfoDialog(true);
							},
						}}
					/>

					<ConfirmDialog
						title={`¿Estás seguro de que quieres ${
							selectedSupplier?.activo ? "desactivar" : "activar"
						} este proveedor?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusSupplier(
								selectedSupplier.id,
								!selectedSupplier?.activo,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: `${
												selectedSupplier?.activo
													? "¡Desactivado!"
													: "¡Activado!"
											}`,
											customMessage: `Proveedor ${
												selectedSupplier?.activo
													? "desactivado"
													: "activado"
											} con éxito`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: `No se ha podido ${
											selectedSupplier?.activo
												? "desactivar"
												: "activar"
										} el proveedor.`,
									});
								});
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar este proveedor?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteSupplier(
								selectedSupplier?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminado!",
											customMessage:
												"Proveedor eliminado con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar el proveedor.",
									});
								});
						}}
					/>
					<EntityInfoDialog
						title={"Proveedor: " + selectedSupplier?.nombre}
						open={openSupplierInfoDialog}
						setOpen={setOpenSupplierInfoDialog}
						content={
							<SupplierContent supplier={selectedSupplier} />
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
